import React, { useState } from 'react';
import { useAccount } from 'wagmi';
import { useSearchParams } from 'react-router-dom';
import { FaLayerGroup, FaChartLine, FaHistory } from 'react-icons/fa';
import { useT } from '../../i18n';
import { storedReferrer } from '../../referral';
import { useGetPredictionsStatus } from './context/PredictionsContext';
import History from './History';
import GameBoard from './components/GameBoard';
import Chart from './Chart';
import GameBar from './components/GameBar';
import ErrorNotification from './components/Notification/ErrorNotification';
import PauseNotification from './components/Notification/PauseNotification';

const TABS = [
  ['rounds', 'bvb.rounds', FaLayerGroup],
  ['chart', 'bvb.chart', FaChartLine],
  ['history', 'bvb.history', FaHistory],
];

/** Phones: status bar, tabs (rounds / chart / history) and the rounds carousel snapping card by card */
const Mobile = () => {
  const t = useT();
  const status = useGetPredictionsStatus();
  const { address } = useAccount();
  const [searchParams] = useSearchParams();
  const [tab, setTab] = useState('rounds');

  const ref = searchParams.get('ref') || storedReferrer(address);
  const referralAddress = ref && ref.toLowerCase() !== address?.toLowerCase() ? ref : null;

  return (
    <div className="flex flex-col">
      <GameBar compact />

      <div className="mx-3 mt-3 grid grid-cols-3 gap-1 rounded-xl bg-black/40 p-1">
        {TABS.map(([key, label, Icon]) => (
          <button
            key={key}
            onClick={() => setTab(key)}
            className={`flex items-center justify-center gap-1.5 rounded-lg py-2 text-xs font-semibold transition-colors ${
              tab === key ? 'bg-brand text-white' : 'text-white/55'
            }`}
          >
            <Icon size={12} /> {t(label)}
          </button>
        ))}
      </div>

      <div className="py-4">
        {tab === 'rounds' && (
          <>
            {status === 'error' && <ErrorNotification />}
            {status === 'paused' && <PauseNotification />}
            {status === 'loading' && <p className="py-16 text-center text-white/40">{t('bvb.loading')}</p>}
            {status === 'live' && <GameBoard referralAddress={referralAddress} mobile />}
          </>
        )}
        {tab === 'chart' && (
          <div className="h-[60vh] px-3">
            <Chart />
          </div>
        )}
        {tab === 'history' && (
          <div className="px-1">
            <History />
          </div>
        )}
      </div>
    </div>
  );
};

export default Mobile;
